// extracted by mini-css-extract-plugin
module.exports =  {"table":"table__WQIV5","editableOffset":"editableOffset__px2-p","productSpecInput":"productSpecInput__ja0xe","emptyBtn":"emptyBtn__Zb-vW"};